import HypothesisDetailContainer from 'containers/HypothesisDetailContainer';

export default (props: any) => {
  return <HypothesisDetailContainer {...props} />;
};
